import { Component, ElementRef, forwardRef, OnDestroy, OnInit, Renderer2, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core';
import { finalize } from 'rxjs/operators';
import { RandomUsernameService } from 'app/core/random-username.service';
import { ModalService } from 'app/shared/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorManagerService } from 'app/core/error-manager.service';
import { RecaptchaComponent } from 'ng-recaptcha';

@Component({
  selector: 'app-forgot-password-modal',
  templateUrl: './forgot-password-modal.template.html',
  styleUrls: ['./forgot-password-modal.template.scss'],
  animations: [],
})
export class ForgotPasswordModalComponent implements OnInit, OnDestroy {
  loadingLogin: boolean = false;
  form: FormGroup;
  loading = false;
  errors: string = null;
  success: string = null;

  @ViewChild('captchaRef') captchaRef: RecaptchaComponent;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private auth: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private nick: RandomUsernameService,
    private translate: TranslateService,
    private modalService: ModalService,
    protected renderer: Renderer2
  ) {
    // super(elemRef, renderer);
  }

  public ngOnInit() {
    // super.ngOnInit();
    this.createForm();
  }

  public ngOnDestroy() {}

  public requestPasswordReset($event: string): void {
    const email = this.form.get('email').value;
    if (!email) {
      this.translate.get(['alert.error', 'authorization_popup.reset_alert_email']).subscribe(trans => {
        this.modalService.openAlert({
          title: trans['alert.error'],
          text: trans['authorization_popup.reset_alert_email'],
        });
      });
      return;
    }
    this.auth
      .requestPasswordReset(email, $event)
      .pipe(finalize(() => {}))
      .subscribe(
        () => {
          this.captchaRef.reset();
          this.translate.get(['alert.success', 'authorization_popup.reset_alert_success']).subscribe(trans => {
            this.modalService.openAlert({
              title: trans['alert.success'],
              text: trans['authorization_popup.reset_alert_success'],
            });
          });
        },
        error => {
          this.captchaRef.reset();
          if (error.status < 500) {
            this.translate.get(['alert.error']).subscribe(trans => {
              this.modalService.openAlert({
                title: trans['alert.error'],
                text: error.json().message,
              });
            });
          } else {
            this.translate.get(['alert.error', 'authorization_popup.reset_alert_success']).subscribe(trans => {
              this.modalService.openAlert({
                title: trans['alert.error'],
                text: trans['alert.unknown_error'],
              });
            });
          }
        }
      );
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/forgot-password/forgot-password-modal.component.ts